import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  file: yup
    .mixed()
    .test('required', 'Обязательно должен быть выбран файл', (value) => value !== null)
    .test('format', 'Файл может быть только в формате .xlsx или .xls', (value) => {
      if (value instanceof File) {
        const fileExtension = value.name.split('.').pop()?.toLowerCase();
        return fileExtension === 'xlsx' || fileExtension === 'xls';
      }
    })
    .nullable(),
});
